
import { Component, Prop, Vue } from 'vue-property-decorator';
import { BIconArrowClockwise } from 'bootstrap-vue';
import TicketsModule, {
  TicketJobLinkageEnum,
  isTicketId,
} from '../../store/tickets.module';
import { TICKET_PRESETS } from './ticketPresets';
import { SELECTABLE_TICKET_STATUSES, statusLabelKey } from './ticketStatus';

@Component({ components: { BIconArrowClockwise } })
export default class TicketFilterBar extends Vue {
  @Prop({ required: true }) store!: TicketsModule;
  @Prop({ default: () => [] }) departments!: any[];
  @Prop({ default: null }) activePreset!: string | null;

  presets = TICKET_PRESETS;

  get hasSearchTerm(): boolean {
    return !!(this.store.filters.search || '').trim();
  }
  /** An id search already ignores every filter, so widening it is a no-op. */
  get isTicketIdSearch(): boolean {
    return isTicketId(this.store.filters.search || '');
  }

  get statusModel(): string[] {
    return this.store.filters.status;
  }
  set statusModel(value: string[]) {
    this.store.filters.status = value as any;
  }
  get statusOptions() {
    return SELECTABLE_TICKET_STATUSES.map((value) => ({
      value,
      text: this.$t(statusLabelKey(value)),
    }));
  }
  get statusButtonText() {
    const selected = this.store.filters.status;
    if (!selected.length) return this.$t('tickets.status_any');
    if (selected.length === 1) return this.$t(statusLabelKey(selected[0]));
    return this.$t('tickets.status_n_selected', { n: selected.length });
  }
  get departmentOptions() {
    return [
      { value: null, text: this.$t('tickets.all_departments') },
      ...this.departments.map((d) => ({
        value: d.department_id,
        text: d.name,
      })),
    ];
  }
  get jobLinkageOptions() {
    return [
      {
        value: TicketJobLinkageEnum.ANY,
        text: this.$t('tickets.job_link_any'),
      },
      {
        value: TicketJobLinkageEnum.HAS,
        text: this.$t('tickets.job_link_has'),
      },
      {
        value: TicketJobLinkageEnum.NONE,
        text: this.$t('tickets.job_link_none'),
      },
      {
        value: TicketJobLinkageEnum.SPECIFIC,
        text: this.$t('tickets.job_link_specific'),
      },
    ];
  }
  get showJobName() {
    return this.store.filters.jobLinkage === TicketJobLinkageEnum.SPECIFIC;
  }
}
